// 导入pako
import pako from 'pako'

// b64Data-->传入加密的数据进行解密
function unzip (b64Data) {
	// debugger
	// const zurltxt = Buffer.from(decodeURIComponent(b64Data), 'base64').toString('utf8')
	// console.log(zurltxt)
	// 先 base64编码
	// 加密：window.btoa()，解密：window.atob()
	// let strData = window.atob(b64Data)
	let strData = window.atob(b64Data)
	// console.log(strData)
	// let strData = decrypt(b64Data)
	// Convert binary string to character-number array 字符串转数组 在循环返回一个 Unicode表所在位置的新数组
	const charData = strData.split('').map(function (x) { return x.charCodeAt(0) })
	// Turn number array into byte-array Uint8Array 数组类型表示一个8位无符号整型数组，创建时内容被初始化为0。创建完后，可以以对象的方式或使用数组下标索引的方式引用数组中的元素。
	const binData = new Uint8Array(charData)
	// // unzip 调用pako 解析
	let data = pako.inflate(binData)
	// data = Utf8ArrayToStr(data)
	data = new TextDecoder('utf-8').decode(data)
	// console.log(data)

	// Convert gunzipped byteArray back to ascii string: 接受 Unicode 值，然后返回字符串
	// strData = String.fromCharCode.apply(null, new Uint16Array(data))
	// strData = ''
	// let chunk = 8 * 1024
	// let i
	// for (i = 0; i < data.length / chunk; i++) {
	// 	strData += String.fromCharCode.apply(null, data.slice(i * chunk, (i + 1) * chunk))
	// }
	// strData += String.fromCharCode.apply(null, data.slice(i * chunk))
	// strData = percent2percent25(strData)
	// console.log(strData)
	return decodeURIComponent(encodeURIComponent(data))
}

// 加密
function zip (str) {
	if (typeof str !== 'string') {
		str = JSON.stringify(str)
	}
	const binaryString = pako.gzip(str, { to: 'string' })
	return window.btoa(binaryString)
}
// const percent2percent25 = (URI) => {
// 	if (URI.indexOf('%') > -1) {
// 		return URI.replace(/%/g, '%25')
// 	} else {
// 		return URI
// 	}
// }

// const Utf8ArrayToStr = function (array) { // 数据流转化为字符串, 兼容汉字
// 	var out = ''
// 	var i = 0
// 	var len = array.length
// 	var char1, char2, char3, char4
// 	while (i < len) {
// 		char1 = array[i++]
// 		// 当单个字节时, 最大值 '01111111', 最小值 '00000000' 右移四位 07, 00
// 		// 当两个字节时, 最大值 '11011111', 最小值 '11000000' 右移四位 13, 12
// 		// 当三个字节时, 最大值 '11101111', 最小值 '11100000' 右移四位 14, 14
// 		if (char1 >> 4 <= 7) {
// 			out += String.fromCharCode(char1)
// 		} else if (char1 >> 4 === 12 || char1 >> 4 === 13) {
// 			char2 = array[i++]
// 			out += String.fromCharCode(((char1 & 0x1F) << 6) | (char2 & 0x3F))
// 		} else if (char1 >> 4 === 14) {
// 			char2 = array[i++]
// 			char3 = array[i++]
// 			char4 = ((char1 & 0x0F) << 12) | ((char2 & 0x3F) << 6)
// 			out += String.fromCharCode(char4 | ((char3 & 0x3F) << 0))
// 		}
// 	}
// 	return out
// }

// function decrypt (value) {
// 	if (typeof value === 'string') {
// 		let res = window.atob(value).split('').map(c => {
// 			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
// 		}).join('')
// 		return res
// 		// res = percent2percent25(res)
// 		// return window.decodeURIComponent(res)
// 		// return window.decodeURIComponent(
// 		// 	window.atob(value)
// 		// 	.split('')
// 		// 	.map(function (c) {
// 		// 		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
// 		// 	}).join(''))
// 		// )
// 	} else {
// 		return window.atob(value)
// 	}
// }
export {
	unzip,
	zip
}
